import { Button, Toolbar, Typography, IconButton, Box } from "@mui/material";
import Logo from '../../static/BloombergLPWhite.png';

export const Header = ({ signOut, showHome, goHome }) => {
  return (
    <Toolbar sx={{ borderBottom: 1, borderColor: "divider" }}>
      <Box
        component="img"
        sx={{ height: 30, mr: 3}}
        alt="logo"
        src={Logo}
      >
      </Box>
      {showHome && (<Button
         onClick={goHome}
         variant="contained"
         size="small"
      >
        Home
      </Button>)}
      <Typography
        component="h2"
        variant="h5"
        color="inherit"
        align="center"
        noWrap
        sx={{ flex: 1 }}
      ></Typography>
      <IconButton>{/* <SearchIcon /> */}</IconButton>
      <Button onClick={signOut} variant="contained" size="small">
        Sign Out
      </Button>
    </Toolbar>
  );
};

export default Header;
